import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Loader2 } from 'lucide-react';
import { useNotificationFeed } from '../../hooks/useNotificationFeed';
import { NotificationCategory, LIVE_NOTIFICATION_CATEGORIES, NOTIFICATION_CATEGORY_LABELS } from '../../composables/notificationAPI';
import NotificationRow from './NotificationRow';

interface Props {
  feed: ReturnType<typeof useNotificationFeed>;
  // dropdown: อยู่ในกล่อง popover ที่มี maxHeight ตายตัว ต้อง scroll ในตัวเอง
  // page: อยู่ในหน้าเต็ม ปล่อยให้ผู้ปกครอง (main) เป็นตัว scroll แทน
  variant?: 'dropdown' | 'page';
}

const NotificationFeedList: React.FC<Props> = ({ feed, variant = 'dropdown' }) => {
  const { items, loading, loadingMore, cursor, category, setCategory, unreadOnly, setUnreadOnly, loadFeed, toggleRead, acknowledge, dismiss, open } = feed;

  return (
    <>
      <div className="flex items-center gap-2 px-4 py-2 border-b" style={{ borderColor: 'var(--bg-item)' }}>
        <select
          value={category}
          onChange={(e) => setCategory(e.target.value as NotificationCategory | '')}
          className="text-xs rounded-lg px-2 py-1.5 flex-1 min-w-0"
          style={{ backgroundColor: 'var(--bg-item)', color: 'var(--text-color)' }}
        >
          <option value="">ทุกหมวด</option>
          {LIVE_NOTIFICATION_CATEGORIES.map((c) => (
            <option key={c} value={c}>{NOTIFICATION_CATEGORY_LABELS[c]}</option>
          ))}
        </select>
        <label className="flex items-center gap-1 text-xs whitespace-nowrap">
          <input type="checkbox" checked={unreadOnly} onChange={(e) => setUnreadOnly(e.target.checked)} />
          ยังไม่อ่าน
        </label>
      </div>

      <div className={variant === 'dropdown' ? 'flex-1 overflow-y-auto' : ''}>
        {loading ? (
          <div className="flex items-center justify-center py-10 opacity-70"><Loader2 className="animate-spin" size={20} /></div>
        ) : items.length === 0 ? (
          <div className="text-center py-10 text-sm opacity-60">ไม่มีแจ้งเตือนในเงื่อนไขนี้</div>
        ) : (
          <AnimatePresence initial={false} mode="popLayout">
            {items.map((n) => (
              <motion.div
                key={n.id}
                layout
                initial={{ opacity: 0, y: -6 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, scale: 0.97 }}
                transition={{ duration: 0.18, ease: 'easeOut' }}
              >
                <NotificationRow
                  item={n}
                  onToggleRead={() => toggleRead(n)}
                  onAcknowledge={() => acknowledge(n)}
                  onDismiss={() => dismiss(n)}
                  onOpen={(url) => open(n, url)}
                />
              </motion.div>
            ))}
          </AnimatePresence>
        )}
        {cursor && !loading && (
          <button
            onClick={() => loadFeed(false)}
            disabled={loadingMore}
            className="w-full py-2.5 text-xs font-semibold opacity-80 hover:opacity-100 transition-opacity"
          >
            {loadingMore ? 'กำลังโหลด...' : 'โหลดเพิ่มเติม'}
          </button>
        )}
      </div>
    </>
  );
};

export default NotificationFeedList;
